export default __webpack_public_path__ + "static/media/cif-bd.45cd9ad6.svg";